import useTrans from '@/hooks/useTrans';
import { message } from 'antd';
import BreadcrumbComponent from '../Other/BreadCrumbComponent';
import MetaSeo from '../MetaSeo';
import { useEffect, useRef, useState } from 'react';
import styles from '../../components/InvestGoldCourse/investgoldcourse.module.css';

const ACTION_FORM_SUBMIT = process.env.NEXT_PUBLIC_URL_SHEET_2;

const InvestGoldCourse = ({ title_seo, description, text_footer }) => {
  const trans = useTrans();
  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = phone => {
    const phoneRegex = /^0\d{9}$/;
    return phoneRegex.test(phone);
  };

  const validateRequiredField = field => {
    return field && field.trim() !== '';
  };

  const isMobileDevice = () => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  const success = () => {
    try {
      isMobileDevice()
        ? messageApi.open({
            type: 'success',
            content: trans.priority.sucess_form, // mobile là cái này
          })
        :       message.success(trans.priority.sucess_form); // máy tính là cái này
    } catch (error) {
      console.log('run to error==========================>', error);
      message.success(trans.priority.sucess_form);
    }
  };

  useEffect(() => {
    const form = document.getElementById('form_submit');

    const handleSubmit = event => {
      event.preventDefault();

      const formData = new FormData(form);
      const name = formData.get('Name');
      const email = formData.get('Email');
      const phone = formData.get('Phone');
      const user_ref = formData.get('User_Ref');
      const reason = formData.get('Reason');      

      if (!validateRequiredField(name)) {
        message.error(`Họ tên ${trans.priority.required}`);
        return;
      }

      if (!validateEmail(email)) {
        message.error(trans.priority.invalid_email);
        return;
      }

      if (!validateRequiredField(reason)) {
        message.error(`Lí do ${trans.priority.required}`);
        return;
      }

      if (!validatePhone(phone)) {
        message.error(trans.priority.invalid_phone);
        return;
      }

      success();
      setIsLoading(true);
      isMobileDevice() && form.reset();
      fetch(form.action, {
        method: 'POST',
        body: formData,
      })
        .then(response => response.text())
        .then(data => {
          !isMobileDevice() && ( success(), form.reset());
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error:', error);
          setIsLoading(false);
        });
    };

    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    return () => {
      if (form) {
        form.removeEventListener('submit', handleSubmit);
      }
    };
  }, []);

  const dataSeo = {
    title: title_seo || 'Chương trình đào tạo miễn phí HanaGold',
    description: description || 'HanaGold mong muốn hia sẻ kiến thức về phương pháp tích vàng, góp phần phát triển cộng đồng, giúp khách hàng hướng đến sự thịnh vượng bền vững.',
    url: 'https://hanagold.vn/khoa-hoc-dau-tu-vang',
    image:
      'https://api.hanagold.vn/media-new/1729246922269-investgoldcourseurlimagepng.png',
  };
  return (
    <>
      <MetaSeo {...dataSeo} />
      <main>
        {contextHolder}
        <section className={styles.padding_mobile}></section>
        <section className={`${styles.section_breadcrumb} ${styles.use_sp}`}>
          <div className=''>
            <BreadcrumbComponent isHeader={true} title={trans?.header?.course} url='khoa-hoc-dau-tu-vang'/>
          </div>
        </section>
        <section className={styles.banner_invest}>
          <div className={styles.banner_bg}>
            <div className={styles.container_invest}>
              <div className={`${styles.banner_breadcrumb} ${styles.use_pc}`}>
                <BreadcrumbComponent isHeader={true} title={trans?.header?.course} url='khoa-hoc-dau-tu-vang'/>
              </div>
              <div className={styles.banner_left}>
                <h2 className={styles.banner_left_title}>
                  <span>{trans?.course?.banner_title_1}</span>
                  {trans?.course?.banner_title_2}
                </h2>
                <p onClick={scrollToForm} className={`${styles.banner_left_button} ${styles.use_pc}`}>
                  {trans?.course?.resgister_now}
                </p>
                <p onClick={scrollToForm} className={`${styles.banner_left_button} ${styles.use_sp}`}>
                  {trans?.course?.policy}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.section_2}>
          <div className={styles.container_invest} data-aos='fade-down' data-aos-delay='400'>
            <div className={styles.section_2_top}>
              <h2 className={styles.section_2_top_left}>
                {trans?.course?.title_section_2}
              </h2>
              <div className={`${styles.section_2_top_right} ${styles.use_pc}`}>
                <p>
                  {trans?.course?.description_1_section_2}
                </p>
                <br />
                <p>
                  {trans?.course?.description_2_section_2}
                </p>
              </div>
            </div>
            <div className={styles.section_2_list}>
              <div className={styles.section_2_list_item}>
                {trans?.course?.item_1_section_2}
              </div>
              <div className={styles.section_2_list_item}>
                {trans?.course?.item_2_section_2}
              </div>
              <div className={`${styles.section_2_list_item} ${styles.use_sp}`}>
                {trans?.course?.item_3_section_2}
              </div>
              <div className={styles.section_2_list_item}>
                {trans?.course?.item_4_section_2}
              </div>
            </div>
          </div>
          <div className={styles.section_2_bot} data-aos='fade-up' data-aos-delay='400'>
            <div className={styles.container_invest}>
              <p>
                {trans?.course?.title_bot_section_2}
              </p>
              <h4>{trans?.course?.description_bot_section_2}</h4>
            </div>
          </div>
        </section>
        <section className={styles.section_3}>
          <div className={styles.container_invest} data-aos='fade-down' data-aos-delay='400'>
            <h2 className={`${styles.section_3_title_mobile} ${styles.use_sp}`}>
              <span>{trans?.course?.title_1_section_3}</span>{' '}{trans?.course?.title_2_section_3}
            </h2>
            <div className={styles.section_3_main}>
              <div className={styles.section_3_text}>
                <p>
                  {trans?.course?.description_1_section_3_part_1}
                  <span>{' '}{trans?.course?.description_1_section_3_part_2}</span>
                </p>
                <p className={`${styles.use_pc} ${styles.text_right_pc}`}>
                  {trans?.course?.description_2_section_3_part_1}
                  <br />
                  <span>{' '}{trans?.course?.description_2_section_3_part_2}</span>
                </p>
                <p className={styles.use_sp}>
                  <span>{trans?.course?.description_3_section_3_part_1}</span>{' '}{trans?.course?.description_3_section_3_part_2}
                </p>
              </div>
              <div className={`${styles.use_pc} ${styles.section_3_title}`}>
                <div className={styles.section_3_title_arrow}>
                  <img
                    src='/assets/img/invest-gold-course/arrow-1.svg'
                    alt=''
                  />
                  <img
                    src='/assets/img/invest-gold-course/arrow-2.svg'
                    alt=''
                  />
                </div>
                <h2>
                  <span>{trans?.course?.title_1_section_3}</span>{' '}{trans?.course?.title_2_section_3}
                </h2>
                <div className={styles.section_3_title_arrow}>
                  <img
                    src='/assets/img/invest-gold-course/arrow-3.svg'
                    alt=''
                  />
                  <img
                    src='/assets/img/invest-gold-course/arrow-4.svg'
                    alt=''
                  />
                </div>
              </div>
              <div className={styles.section_3_text}>
                <p className={styles.use_sp}>
                {trans?.course?.description_2_section_3_part_1}
                <span>{' '}{trans?.course?.description_2_section_3_part_2}</span>
                </p>
                <p className={`${styles.use_pc} ${styles.item_3_reason}`}>
                <span>{trans?.course?.description_3_section_3_part_1}</span>{' '}{trans?.course?.description_3_section_3_part_2}
                </p>
                <p className={`${styles.text_right_pc} ${styles.item_4_reason}`}>
                  {trans?.course?.description_4_section_3_part_1}
                  <span>{' '}{trans?.course?.description_4_section_3_part_2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.section_4}>
          <div className={styles.container_invest} data-aos='fade-left' data-aos-delay='600'>
            <div className={styles.section_4_wrap}>
              <div className={styles.section_4_left}>
                <div className={styles.section_4_left_item}>
                  <div className={styles.section_4_left_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-4.png'
                      alt=''
                    />
                    <p>55%</p>
                  </div>
                  <p className={styles.section_4_left_item_name}>{trans?.course?.description_1_section_4}</p>
                </div>
                <div className={styles.section_4_left_item}>
                  <div className={styles.section_4_left_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-4.png'
                      alt=''
                    />
                    <p>10%</p>
                  </div>
                  <p className={styles.section_4_left_item_name}>{trans?.course?.description_2_section_4}</p>
                </div>
                <div className={styles.section_4_left_item}>
                  <div className={styles.section_4_left_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-4.png'
                      alt=''
                    />
                    <p>10%</p>
                  </div>
                  <p className={styles.section_4_left_item_name}>{trans?.course?.description_3_section_4}</p>
                </div>
                <div className={styles.section_4_left_item}>
                  <div className={styles.section_4_left_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-4.png'
                      alt=''
                    />
                    <p>10%</p>
                  </div>
                  <p className={styles.section_4_left_item_name}>
                    {trans?.course?.description_4_section_4}
                  </p>
                </div>
                <div className={styles.section_4_left_item}>
                  <div className={styles.section_4_left_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-4.png'
                      alt=''
                    />
                    <p>10%</p>
                  </div>
                  <p className={styles.section_4_left_item_name}>
                    {trans?.course?.description_5_section_4}
                  </p>
                </div>
                <div className={styles.section_4_left_item}>
                  <div className={styles.section_4_left_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-4.png'
                      alt=''
                    />
                    <p>5%</p>
                  </div>
                  <p className={styles.section_4_left_item_name}>{trans?.course?.description_6_section_4}</p>
                </div>
              </div>
              <h2 className={styles.section_4_right}>{trans?.course?.title_section_4}</h2>
            </div>
          </div>
        </section>
        <section className={styles.section_5}>
          <div className={styles.container_invest} data-aos='fade-right' data-aos-delay='600'>
            <h2 className={styles.section_5_title}>
              {trans?.course?.title_1_section_5}
              <br className={styles.on_sp} /> {trans?.course?.title_2_section_5}
            </h2>
            <div className={styles.section_5_list}>
              <div className={styles.section_5_list_block_item}>
                <div className={styles.section_5_overlay_item}></div>
                <div className={styles.section_5_list_item}>
                  <div className={styles.section_5_list_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-5.1.png'
                      alt=''
                    />
                  </div>
                  <div className={styles.section_5_list_item_content}>
                    <p className={styles.section_5_list_item_text}>
                      {trans?.course?.description_1_section_5}
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.section_5_list_block_item}>
                <div className={styles.section_5_overlay_item}></div>
                <div className={styles.section_5_list_item}>
                  <div className={styles.section_5_list_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-5.2.png'
                      alt=''
                    />
                  </div>
                  <div className={styles.section_5_list_item_content}>
                    <p className={styles.section_5_list_item_text}>
                      {trans?.course?.description_2_section_5}
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.section_5_list_block_item}>
                <div className={styles.section_5_overlay_item}></div>
                <div className={styles.section_5_list_item}>
                  <div className={styles.section_5_list_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-5.3.png'
                      alt=''
                    />
                  </div>
                  <div className={styles.section_5_list_item_content}>
                    <p className={styles.section_5_list_item_text}>
                      {trans?.course?.description_3_section_5}
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.section_5_list_block_item}>
                <div className={styles.section_5_overlay_item}></div>
                <div className={styles.section_5_list_item}>
                  <div className={styles.section_5_list_item_img}>
                    <img
                      src='/assets/img/invest-gold-course/img-section-5.4.png'
                      alt=''
                    />
                  </div>
                  <div className={styles.section_5_list_item_content}>
                    <p className={styles.section_5_list_item_text}>
                      {trans?.course?.description_4_section_5}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.section_6}>
          <div className={styles.container_invest}>
            <h2 className={styles.section_6_title} data-aos='fade-up' data-aos-delay='400'>
              {trans?.course?.title_1_section_6}<span>{' '}{trans?.course?.title_2_section_6}</span> <br className='on-sp' /> {trans?.course?.title_3_section_6}
            </h2>
            <div className={styles.section_6_list} data-aos='fade-down' data-aos-delay='400'>
              <div className={styles.section_6_list_item}>
                <div className={styles.section_6_list_item_img}>
                  <img
                    src='/assets/img/invest-gold-course/img-section-6.1.png'
                    alt=''
                    className={styles.on_pc}
                  />
                  <img
                    src='/assets/img/invest-gold-course/img-section-6.1-sp.png'
                    alt=''
                    className={styles.on_sp}
                  />
                </div>
                <div className={styles.section_6_list_item_content}>
                  <p>{trans?.course?.day_1_title}</p>
                  <ul>
                    <li>
                      {trans?.course?.day_1_description_1}
                    </li>
                    <li>
                      {trans?.course?.day_1_description_2}
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.section_6_list_item}>
                <div className={styles.section_6_list_item_img}>
                  <img
                    src='/assets/img/invest-gold-course/img-section-6.2.png'
                    alt=''
                    className={styles.on_pc}
                  />
                  <img
                    src='/assets/img/invest-gold-course/img-section-6.2-sp.png'
                    alt=''
                    className={styles.on_sp}
                  />
                </div>
                <div className={styles.section_6_list_item_content}>
                  <p>{trans?.course?.day_2_title}</p>
                  <ul>
                    <li>{trans?.course?.day_2_description_1}</li>
                    <li>
                      {trans?.course?.day_2_description_2}
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.section_6_list_item}>
                <div className={styles.section_6_list_item_img}>
                  <img
                    src='/assets/img/invest-gold-course/img-section-6.3.png'
                    alt=''
                    className={styles.on_pc}
                  />
                  <img
                    src='/assets/img/invest-gold-course/img-section-6.3-sp.png'
                    alt=''
                    className={styles.on_sp}
                  />
                </div>
                <div className={styles.section_6_list_item_content}>
                  <p>
                  {trans?.course?.day_3_title}
                  </p>
                  <ul>
                    <li>
                      {trans?.course?.day_3_description_1}
                    </li>
                    <li>
                      {trans?.course?.day_3_description_2}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.section_7}>
          <div className={styles.container_invest}>
            <h2 className={`${styles.section_7_title} ${styles.on_pc}`} data-aos='fade-up' data-aos-delay='400'>
              {trans?.course?.title_1_section_7_pc} <br />{' '}
              <span> {trans?.course?.title_2_section_7_pc}</span>
            </h2>
            <h2 className={`${styles.section_7_title} ${styles.on_sp}`} data-aos='fade-up' data-aos-delay='400'>
              <span>{trans?.course?.title_1_section_7_mb}</span>{' '}{trans?.course?.title_2_section_7_mb}{' '}{trans?.course?.title_3_section_7_mb}
            </h2>
            <div className={styles.section_7_list}>
              <div className={styles.section_7_list_item} data-aos='fade-right' data-aos-delay='300'>
                <div className={styles.section_7_list_item_content}>
                  <p>
                    {trans?.course?.description_1_section_7}
                  </p>
                </div>
              </div>
              <div className={styles.section_7_list_item} data-aos='fade-right' data-aos-delay='400'>
                <div className={styles.section_7_list_item_content}>
                  <p>
                    {trans?.course?.description_2_section_7}
                  </p>
                </div>
              </div>
              <div className={styles.section_7_list_item} data-aos='fade-right' data-aos-delay='500'>
                <div className={styles.section_7_list_item_content}>
                  <p>
                    {trans?.course?.description_3_section_7}
                  </p>
                </div>
              </div>
              <div className={styles.section_7_list_item} data-aos='fade-left' data-aos-delay='300'>
                <div className={styles.section_7_list_item_content}>
                  <p>
                    {trans?.course?.description_4_section_7}
                  </p>
                </div>
              </div>
              <div className={styles.section_7_list_item} data-aos='fade-left' data-aos-delay='400'>
                <div className={styles.section_7_list_item_content}>
                  <p>
                    {trans?.course?.description_5_section_7}
                  </p>
                </div>
              </div>
              <div className={styles.section_7_list_item} data-aos='fade-left' data-aos-delay='500'>
                <div className={styles.section_7_list_item_content}>
                  <p>
                    {trans?.course?.description_6_section_7}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.section_8}>
          <div className={styles.section_8_bg}>
            <div className={styles.container_invest} data-aos='fade-left' data-aos-delay='400'>
              <div className={styles.section_8_content}>
                <p className={styles.section_8_content_title}>{trans?.business_solutions?.about_title}</p>
                <div className={`${styles.section_8_content_text} ${styles.use_pc}`}>
                  <p>
                    {trans?.business_solutions?.about_description_3}
                  </p>
                  <p>
                    {trans?.business_solutions?.about_description_4}
                  </p>
                  <p>
                    {trans?.business_solutions?.about_description_5}
                  </p>
                </div>
                <div className={`${styles.section_8_content_text} ${styles.use_sp}`}>
                  <p>
                    {trans?.business_solutions?.about_description_1}
                  </p>
                  <p>
                    {trans?.business_solutions?.about_description_2}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.section_9}>
          <div className={styles.section_9_bg}>
            <div className={styles.container_invest}>
              <div className={styles.section_9_content}>
                <h2 className={styles.section_9_title} data-aos='fade-up' data-aos-delay='400'>
                  {trans?.course?.title_section_9}
                </h2>
                <ul className={styles.section_9_list}>
                  <li className={styles.section_9_list_item} data-aos='fade-right' data-aos-delay='400'>
                    1.{' '}{trans?.course?.description_1_section_9}
                  </li>
                  <li className={`${styles.section_9_list_item} ${styles.item_4}`} data-aos='fade-left' data-aos-delay='400'>
                    <span>2.</span>
                    {trans?.course?.description_2_section_9}
                  </li>
                  <li className={`${styles.section_9_list_item} ${styles.item_4}`} data-aos='fade-right' data-aos-delay='400'>
                    <span>3.</span>
                      {trans?.course?.description_3_section_9}
                  </li>
                  <li className={`${styles.section_9_list_item} ${styles.item_4}`} data-aos='fade-left' data-aos-delay='400'>
                    <span>4.</span>
                    <span>
                      {trans?.course?.description_4_section_9}
                    </span>
                  </li>
                </ul>
                <p className={styles.section_9_note} data-aos='fade-down' data-aos-delay='400'>
                  {trans?.course?.note_section_9}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section ref={formRef}></section>
        <section className={styles.section_10}>
          <div className={styles.section_10_bg}>
            <div className={styles.container_invest}>
              <form
                id='form_submit'
                method='POST'
                action={ACTION_FORM_SUBMIT}
              >
                <p className={styles.section_10_sub_title} data-aos='fade-left' data-aos-delay='400'>
                  {trans?.course?.title_1_section_10}
                </p>
                <h2 className={styles.section_10_title} data-aos='fade-right' data-aos-delay='400'>{trans?.course?.title_2_section_10}
                </h2>
                <div className={styles.section_10_input_wrap}>
                  <input type='text' name='Name' placeholder={trans?.course?.fullname} data-aos='fade-left' data-aos-delay='400' />
                  <input type='email' name='Email' placeholder={trans?.course?.email} data-aos='fade-right' data-aos-delay='400' />
                  <input type='number' name='Phone' placeholder={trans?.course?.phone} data-aos='fade-left' data-aos-delay='400' />
                  <input type='text' name='User_Ref' placeholder={trans?.course?.ref} data-aos='fade-right' data-aos-delay='400' />
                  <input
                    type='text'
                    name='Reason'
                    placeholder={trans?.course?.reason}
                    data-aos='fade-left' data-aos-delay='400'
                  />
                </div>
                <button disabled={isLoading} data-aos='fade-right' data-aos-delay='400' type='submit'>
                  {trans?.course?.register}
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default InvestGoldCourse;
